import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { ALIGN_PROPS } from './UIColumnConstants';
import UIAbstractColumn from './abstract/UIAbstractColumn';
export default function UIColumnSpreads(_ref) {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/_jsx(UIAbstractColumn, Object.assign({}, props, {
    columnType: "spreads",
    children: children
  }));
}
UIColumnSpreads.propTypes = {
  align: PropTypes.oneOf(ALIGN_PROPS),
  alignSelf: PropTypes.oneOf(ALIGN_PROPS),
  expands: PropTypes.bool,
  overflow: PropTypes.bool,
  children: PropTypes.node
};
UIColumnSpreads.displayName = 'UIColumnSpreads';